import styled from 'styled-components';

export const StyledMoneyBadgeImage = styled.img`
  position: relative;
  display: inline-block;
  margin-left: 16px;
  margin-right: 16px;
`;
